module.exports = __webpack_public_path__ + "img/logo13.4774fc39.png";